<template>
  <div>
    <div class="headline primary--text mb-3">Report</div>

    <Export @submit="handleExportSubmit" />
  </div>
</template>

<script>
import Export from './Export.vue'

export default {
  components: {
    Export
  },
  methods: {
    handleExportSubmit(value) {
      console.log('export submit', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Report/index.vue